App.namespace.wrap('es6.shared.spinner', () => {
  const createArrow = type => {
    const isTop = type === 'top';
    const arrow = document.createElement('a');

    arrow.tabIndex = -1;
    arrow.className = 'input-spinner-arrow';
    arrow.style.borderStyle = 'solid';
    arrow.style.cursor = 'pointer';
    arrow.style.outline = 'none';
    arrow.style.position = 'absolute';
    arrow.style.right = '11px';
    arrow.style.top = '50%';

    arrow.style.borderColor = isTop ? 'transparent transparent #00a287' : '#00a287 transparent transparent';
    arrow.style.borderWidth = isTop ? '0 5px 8px' : '8px 5px 0';
    arrow.style.transform = isTop ? 'translateY(-10px)' : 'translateY(2px)';

    return arrow;
  };

  const createSpinner = input => {
    if (input.dataset.spinnerInitialized === "true") {
      return;
    }

    // browser unsupported
    if (!input.insertAdjacentElement) {
      return;
    }

    let interval;
    const repeatInterval = 80;
    const max = parseInt(input.max, 10) || 99999;
    const min = parseInt(input.min, 10) || 0;
    const step = parseInt(input.step, 10) || 1;
    const arrowTop = createArrow('top');
    const arrowBottom = createArrow('bottom');

    const increase = value => value + step > max ? max : value + step;
    const decrease = value => value - step < min ? min : value - step;
    const clearEventInterval = () => clearInterval(interval);
    const getCurrentValue = inputElement => parseInt(inputElement.value, 10) || 0;
    const ensureInputHasFocus = () => {
      if (input !== document.activeElement) {
        input.focus();
      }
    }

    input.parentElement.style.position = 'relative';

    arrowTop.addEventListener('click', ensureInputHasFocus);
    arrowBottom.addEventListener('click', ensureInputHasFocus);

    arrowTop.addEventListener('mousedown', event => {
      if (event.button !== 0) {
        return;
      }

      ensureInputHasFocus();
      event.preventDefault();
      interval = setInterval(() => {
        input.value = increase(getCurrentValue(input));
        input.dispatchEvent(new Event('input'));
      }, repeatInterval);
    });

    arrowBottom.addEventListener('mousedown', event => {
      if (event.button !== 0) {
        return;
      }

      ensureInputHasFocus();
      event.preventDefault();
      interval = setInterval(() => {
        input.value = decrease(getCurrentValue(input));
        input.dispatchEvent(new Event('input'));
      }, repeatInterval);
    });

    arrowTop.addEventListener('mouseup', clearEventInterval);
    arrowTop.addEventListener('mouseleave', clearEventInterval);
    arrowBottom.addEventListener('mouseup', clearEventInterval);
    arrowBottom.addEventListener('mouseleave', clearEventInterval);

    input.insertAdjacentElement('afterend', arrowTop);
    input.insertAdjacentElement('afterend', arrowBottom);

    input.dataset.spinnerInitialized = "true";
  };

  return {
    create: createSpinner
  }
});
